module.exports = __webpack_public_path__ + "img/mastercard.13002e04.png";